import { MAPS_KEY, MAPS_STORAGE_IDENTIFIER } from '$c3local/constants.js';

export function sponsorListFilter() {
    const form = $('.sponsors-list-search');
    const input = form.find('input');
    const mappedItems = [];
    const typeCounts = {};
    const categoryCounts = {};
    $('.sponsors-list-item').each(function () {
        const sectionEl = $(this).parents('.sponsors-list-items-section');
        const tabPaneId = $(this).parents('.tab-pane').attr('id');
        const tabHeader = $(`.tab-header[aria-controls="${tabPaneId}"]`);
        const typeIdentifier = sectionEl.data('type-identifier');
        const [categoryIdentifier] = typeIdentifier.split('-');

        if (typeCounts[typeIdentifier]) {
            typeCounts[typeIdentifier].count++;
        } else {
            typeCounts[typeIdentifier] = {
                count: 1,
                sectionEl
            };
        }

        if (categoryCounts[categoryIdentifier]) {
            categoryCounts[categoryIdentifier].count++;
        } else {
            categoryCounts[categoryIdentifier] = {
                count: 1,
                tabHeader
            };
        }

        mappedItems.push({
            title: $(this).data('sponsor')?.toLowerCase() ?? '',
            el: $(this),
            typeIdentifier,
            categoryIdentifier
        });
    });

    form.submit(function (e) {
        e.preventDefault();
        const search = input.val();

        const clonedTypeCounts = {};
        Object.entries(typeCounts).forEach(([key, data]) => {
            clonedTypeCounts[key] = {count: data.count};
        });

        const clonedCategoryCounts = {};
        Object.entries(categoryCounts).forEach(([key, data]) => {
            clonedCategoryCounts[key] = {count: data.count};
        });

        mappedItems.forEach(item => {
            const matches = item.title.includes(search);
            item.el.parent().toggleClass('sponsors-list-item-hidden', !matches);

            if (!matches) {
                clonedTypeCounts[item.typeIdentifier].count--;
                clonedCategoryCounts[item.categoryIdentifier].count--;
            }
        });

        Object.entries(clonedTypeCounts).forEach(([key, data]) => {
            typeCounts[key].sectionEl.toggleClass('sponsors-list-items-section-hidden', data.count === 0);
        });

        let firstValidTab;
        Object.entries(clonedCategoryCounts).forEach(([key, data]) => {
            categoryCounts[key].tabHeader.toggleClass('tab-header-disabled', data.count === 0);
            if (data.count > 0 && !firstValidTab) {
                firstValidTab = categoryCounts[key].tabHeader;
            }
        });

        console.log(firstValidTab);
        if (firstValidTab) {
            firstValidTab.trigger('click');
        } else {
            $('#tab-header-99-99').trigger('click');
        }
    });
}

export async function initSponsorMap() {
    const mapEl = $('#sponsors-detail-map');
    if (mapEl.length === 0) {
        return;
    }

    const mapsEnabled = localStorage.getItem(MAPS_STORAGE_IDENTIFIER) === 'true';
    if (mapsEnabled) {
        _loadMaps().catch(console.error);
    } else {
        const enableBtn = $('#sponsors-detail-enable-maps');
        const container = enableBtn.parents('.sponsors-detail-map');
        container.addClass('maps-disabled');
        enableBtn.one('click', function () {
            localStorage.setItem(MAPS_STORAGE_IDENTIFIER, 'true');
            container.removeClass('maps-disabled');
            _loadMaps().catch(console.error);
        });
    }

    async function _loadMaps() {
        const {Loader} = await import('$c3local/Lib/google-maps/Loader.js');

        const [latS, lngS] = mapEl.data('coords').split(',');
        const lat = parseFloat(latS);
        const lng = parseFloat(lngS);

        const loader = new Loader({
            apiKey: MAPS_KEY,
            version: 'weekly',
            libraries: ['places']
        });
        const google = await loader.load();
        const map = new google.maps.Map(mapEl[0], {
            center: {
                lat,
                lng
            },
            zoom: 13
        });

        new google.maps.Marker({
            map,
            position: {
                lat,
                lng
            },
            title: mapEl.data('title')
        });

        const searchForm = $('.sponsors-detail-search');
        const searchInput = searchForm.find('input');
        const searchBox = new google.maps.places.SearchBox(searchInput[0]);

        searchBox.addListener('places_changed', () => {
            const places = searchBox.getPlaces();

            if (places.length === 0) {
                return;
            }

            const bounds = new google.maps.LatLngBounds();

            places.forEach(place => {
                if (!place.geometry || !place.geometry.location) {
                    return;
                }

                if (place.geometry.viewport) {
                    bounds.union(place.geometry.viewport);
                } else {
                    bounds.extend(place.geometry.location);
                }
            });

            map.fitBounds(bounds);
        });

        searchForm.submit(function (e) {
            e.preventDefault();
            searchInput[0].focus();
            google.maps.event.trigger(searchInput[0], 'keydown', {keyCode: 13});
        });
    }
}